import React from "react";
import { Container } from "react-bootstrap";

const AboutOurCompany = () => {
  return (
    <div className="company-wrapper py-5" data-aos="fade-up">
      <Container>
        <h1 className="text-center mb-2 fw-bold">About Our Company</h1>
        <p className="text-center mt-3">
          This ambitious young organization, born 35 years ago, has the sourcing
          expertise for Naphthenic & Paraffinic Base Oils, Ink Oil, Paraffin
          Wax, Micro Crystalline Wax, Polyethylene Waxes and other Specialty
          Oils from USA. The team is headed by Mr. Digant D. Mistry a Chemical
          Engineer. We have qualified support staff.
        </p>
      </Container>
    </div>
  );
};

export default AboutOurCompany;
